<template>
  <div id="Zbcp">
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane label="漆面膜" name="first"></el-tab-pane>
      <el-tab-pane label="窗膜" name="second"></el-tab-pane>
    </el-tabs> -->
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="系列名称：">
          <el-input v-model.trim="Name" clearable></el-input>
        </el-form-item>
        <el-form-item label="产品名称：" prop="productId">
          <el-select
            v-model="queryForm.productId"
            clearable
            filterable
            remote
            :remote-method="handleGetProduct"
            placeholder="--选择产品--"
          >
            <el-option
              v-for="item in productIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标签：" prop="tag">
          <el-select
            v-model="queryForm.tag"
            clearable
            placeholder="--选择标签--"
          >
            <el-option
              v-for="(item, index) in tagLists"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="550"
          row-key="Id"
          id="table"
          ref="table"
        >
          <el-table-column prop="id" label="编号" key="id"> </el-table-column>
          <el-table-column prop="name" label="系列名称" key="name">
          </el-table-column>
          <el-table-column prop="sort" label="位置" key="sort">
          </el-table-column>
          <el-table-column
            prop="productName"
            label="产品名称"
            key="productName"
          >
          </el-table-column>
          <el-table-column prop="tag" label="标签" key="tag"> </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="100" prop="todo" label="操作" key="todo">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
              <span class="handle el-icon-rank"></span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改系列"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="位置：" prop="sort">
          <el-input
            v-model="editForm.sort"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品名称：" prop="productId">
          <el-select
            v-model="editForm.productId"
            clearable
            filterable
            remote
            :remote-method="handleGetProduct"
            placeholder="--选择产品--"
          >
            <el-option
              v-for="item in productIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系列名称：" prop="name">
          <el-input v-model.trim="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="tag">
          <el-select
            v-model="editForm.tag"
            placeholder="--选择标签--"
            v-if="editForm.productId == isQmFilm"
          >
            <el-option
              v-for="(item, index) in tagPUList"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select v-model="editForm.tag" placeholder="--选择标签--" v-else>
            <el-option
              v-for="(item, index) in tagList"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容图片：">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="color: red; text-align: center">
          说明：第一张图片为产品Banner图
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加系列"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <!-- 产品系列添加 -->
        <el-form-item label="位置：" prop="sort">
          <el-input
            v-model="newForm.sort"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品名称：" prop="productId">
          <el-select
            v-model="newForm.productId"
            clearable
            filterable
            remote
            :remote-method="handleGetProduct"
            placeholder="--选择产品--"
          >
            <el-option
              v-for="item in productIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系列名称：" prop="name">
          <el-input v-model.trim="newForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="tag">
          <el-select
            v-model="newForm.tag"
            placeholder="--选择标签--"
            v-if="newForm.productId == isQmFilm"
          >
            <el-option
              v-for="(item, index) in tagPUList"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
          <el-select v-model="newForm.tag" placeholder="--选择标签--" v-else>
            <el-option
              v-for="(item, index) in tagList"
              :key="index"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容图片：">
          <el-upload
            :class="imagesWF.length > 9 ? 'hide' : ''"
            action=""
            list-type="picture-card"
            accept="image/*"
            :multiple="true"
            :limit="10"
            :auto-upload="false"
            :file-list="imagesWF"
            :on-change="handleWFOnchange"
            :on-remove="handleWFRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <div style="color: red; text-align: center">
          说明：第一张图片为产品Banner图
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCP, getCPJM, getCPLX } from "./../axios/api";
import moment from "dayjs";
export default {
  name: "Img",
  data() {
    return {
      activeName: "first",
      imagesWF: [],
      productIdList: [], // 产品名称
      isQmFilm: null,
      tagLists: [
        { id: 1, name: "标签一" },
        { id: 2, name: "标签二" },
        { id: 3, name: "标签三" },
        { id: 4, name: "透明车衣" },
        { id: 5, name: "改色车衣" },
      ], // 添加标签
      tagList: [
        { id: 1, name: "标签一" },
        { id: 2, name: "标签二" },
        { id: 3, name: "标签三" },
      ], // 添加标签
      tagPUList: [
        { id: 1, name: "透明车衣" },
        { id: 2, name: "改色车衣" },
      ], // 添加标签
      queryForm: {}, // 根据条件查询表单
      Name: "",
      tableData: [],
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      newData: false,
      newForm: {},
      editFormVisible: false,
      editForm: {
        name: "",
        sort: 0,
        productId: 0,
        tag: "",
      },

      rules: {
        SortId: [{ required: true, message: "请输入位置", trigger: "blur" }],
        Type: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        Name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],

        sort: [{ required: true, message: "请输入位置", trigger: "blur" }],
        name: [{ required: true, message: "请输入系列名称", trigger: "blur" }],
        productId: [
          { required: true, message: "请输入产品名称", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 获取产品
    handleGetProduct(query) {
      let that = this;
      getCPLX
        .getTable({
          pageNumber: 1,
          pageSize: 1000,
          name: query || undefined,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list } = res.data;
            list.map((lis) => {
              if (lis.name == "漆面膜") {
                that.isQmFilm = lis.id;
              }
            });
            that.productIdList = list;
          }
        });
    },
    // 窗膜上传图片时的钩子
    handleWFOnchange(file, fileList) {
      var that = this;
      const formData = new FormData();
      if (file) {
        formData.append("file", file.raw);
      }
      // console.log(formData.get('file'))

      getCPJM
        .upload(formData)
        .then(function (res) {
          console.log(res);
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            // console.log(res.data)

            that.imagesWF.push(res.data);

            that.$message.success("上传成功!");
          }
        })
        .catch(function (res) {});
    },
    // 窗膜上传图片的删除
    handleWFRemove(file, fileList) {
      if (fileList) {
        this.imagesWF = fileList;
      }
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.init();
    },
    // 搜索
    search: function () {
      var that = this;
      that.currentPage = 1;
      that.init();
    },
    // 重置
    reset: function () {
      var that = this;
      that.Name = "";
      that.queryForm = {};
      that.currentPage = 1;
      that.init();
    },
    // 添加
    add: function () {
      this.newData = true;
      if (this.tableData.length == 0) {
        this.newForm = {
          sort: 1,
        };
      } else {
        this.newForm = {
          sort: this.tableData[this.tableData.length - 1].sort + 1,
        };
      }

      this.handleGetProduct(); // 获取系列
    },

    newClose(done) {
      this.newData = false;
      this.$refs["newForm"].clearValidate();

      this.handleGetProduct(); // 获取系列
    },
    newCancel: function () {
      this.newData = false;
      this.$refs["newForm"].clearValidate();
      this.imagesWF = [];

      this.handleGetProduct(); // 获取系列
    },
    newUpdate: function () {
      var that = this;
      that.$refs["newForm"].validate((valid) => {
        if (valid) {
          if (this.activeName == "first") {
            let newImages = [];
            that.imagesWF.map((img) => {
              newImages.push(img.url);
            });

            var data = {
              name: that.newForm.name, // 型号名称
              sort: Number(that.newForm.sort),
              productId: that.newForm.productId,
              tag: that.newForm.tag,
              images: newImages,
            };
            // console.log('添加窗膜数据：',data)
            getCPJM
              .addWFTable(JSON.stringify(data))
              .then(function (res) {
                console.log(res);
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message.success("添加成功!");
                  that.newData = false;
                  that.newForm = {};
                  that.$refs["newForm"].clearValidate();
                  that.imagesWF = [];
                  that.init();
                }
              })
              .catch(function (res) {});
          }
        } else {
        }
      });
    },

    // 编辑
    bj: function (index, row) {
      // console.log(row);
      var that = this;
      that.editForm.name = row.name;
      that.editForm.sort = row.sort;
      that.editForm.id = row.id;
      that.editForm.productId = row.productId;
      that.editForm.tag = row.tag;

      let newData = [];
      row.images.map((img) => {
        let imgs = {};
        imgs.url = img;
        newData.push(imgs);
      });

      that.imagesWF = newData;

      this.editFormVisible = true; //显示弹框

      that.handleGetProduct()
    },
    handleClose(done) {
      this.$refs["editForm"].clearValidate();
      this.editFormVisible = false;
      this.imagesWF = [];

      this.handleGetProduct(); // 获取系列
    },
    handleCancel: function () {
      this.$refs["editForm"].clearValidate();
      this.editFormVisible = false;
      this.imagesWF = [];

      this.handleGetProduct(); // 获取系列
    },
    handleUpdate: function () {
      var that = this;
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          let imagesWFUrl = [];
          that.imagesWF.map((img) => {
            imagesWFUrl.push(img.url);
          });

          let data = {
            sort: Number(that.editForm.sort),
            name: that.editForm.name,
            productId: that.editForm.productId,
            tag: that.editForm.tag,
            images: imagesWFUrl,
          };

          getCPJM
            .updateWFTable(data, that.editForm.id)
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("更新成功!");
                that.editFormVisible = false;
                that.$refs["editForm"].clearValidate();
                that.imagesWF = [];
                that.init();
              }
            })
            .catch(function (res) {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除
    sc: function (index, row) {
      var that = this;
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getCPJM
            .delWFTable({
              id: row.id,
            })
            .then(function (res) {
              // console.log(res);
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              } else {
                that.$message.success("删除成功!");
                that.init();
              }

              // that.init();
            })
            .catch(function (res) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      let data = {
        name: that.Name ? that.Name : undefined,
        productId: that.queryForm.productId
          ? that.queryForm.productId
          : undefined,
        tag: that.queryForm.tag ? that.queryForm.tag : undefined,
        pageSize: that.pagesize,
        pageNumber: that.currentPage,
      };
      // console.log(data)
      //获取窗膜table列表
      getCPJM.getWFTable(data).then(function (res) {
        // console.log(res);
        if (res.code !== 0) {
          that.$alert(res.message + "!", "提示", {
            confirmButtonText: "确定",
          });
        } else {
          const { list, totalNumber } = res.data;
          list.map((lis) => {
            lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
              "YYYY-MM-DD"
            );
          });
          // console.log(list)
          that.total = totalNumber;
          that.tableData = list;
        }
      });

      this.handleGetProduct(); // 获取系列
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-table,
.el-table__expanded-cell {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/page/Cpjm.vue